export enum BookingDetailTab {
	Details = 'details',
	CustomerProfile = 'customerProfile',
	People = 'people',
	Payment = 'payment',
	Messages = 'messages',
	Timeline = 'timeline',
	Assigning = 'assigning'
}
